import { Outlet, useRouterState } from '@tanstack/react-router';
import { needsTopSafeArea } from '@/lib/safe-area';
import { AdminReturnGuard } from '@/components/admin/admin-return-guard';
import { PageViewTracker } from '@/components/page-view-tracker';
import { ChallengePublishToast } from '@/components/challenge-publish-toast';

export function RootLayout() {
  // App native : réserve le haut d'écran (barre d'état) sur toute page qui ne
  // le fait pas déjà — cf. lib/safe-area.ts. Sans effet sur le web (`native:`).
  const padTop = useRouterState({
    select: (s) => needsTopSafeArea(s.matches.map((m) => m.routeId)),
  });
  return (
    <>
      {padTop ? (
        <div className="native:pt-[env(safe-area-inset-top)]">
          <Outlet />
        </div>
      ) : (
        <Outlet />
      )}
      <AdminReturnGuard />
      <PageViewTracker />
      <ChallengePublishToast />
    </>
  );
}
